import {
  type QueryObserverResult,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query'

import type {
  GetWorkerSlotsForAdminCalendarBody,
  GetWorkerSlotsForAdminCalendarResponse,
} from '@front/type/admin'
import type { CustomError } from '@front/type/api'

import { axiosGet } from '../logic/axios/wrappers/axios.get.wrapper'

import { adminWorkerAvailabilities } from './config'

const useGetWorkerSlotsForAdminCalendarKey = `get-worker-slots-for-admin-calendar`

export const useGetWorkerSlotsForAdminCalendarQuery = (
  body: GetWorkerSlotsForAdminCalendarBody,
  monthISO: string,
  idNetwork?: string,
  hubloId?: string,
  options?: UseQueryOptions<
    GetWorkerSlotsForAdminCalendarResponse,
    CustomError
  >,
): QueryObserverResult<GetWorkerSlotsForAdminCalendarResponse, CustomError> =>
  useQuery<GetWorkerSlotsForAdminCalendarResponse, CustomError>({
    queryKey: [
      useGetWorkerSlotsForAdminCalendarKey,
      body.idInstitution,
      body.from,
      body.to,
      idNetwork,
      hubloId,
    ],
    queryFn: async () =>
      axiosGet<GetWorkerSlotsForAdminCalendarResponse>(
        `${adminWorkerAvailabilities
          .replace(':idNetwork', idNetwork || '')
          .replace(':hubloId', hubloId || '')}?month=${monthISO}`,
      ),
    staleTime: 20 * 60 * 1000,
    enabled: !!idNetwork && !!hubloId,
    ...options,
  })
